import { useCallback, useState } from "react";
import { Input, Button } from "@heroui/react";
import { KatexRenderer } from "./KatexRenderer";
import clsx from "clsx";

interface KatexEquationsAltererProps {
  initialEquation?: string;
  onConfirm: (equation: string, inline: boolean) => void;
}

export function KatexEquationAlterer({ onConfirm, initialEquation = "" }: KatexEquationsAltererProps) {
  const [equation, setEquation] = useState<string>(initialEquation);

  const onClick = useCallback(() => {
    onConfirm(equation, true);
  }, [onConfirm, equation]);

  const handleOnKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && (event.ctrlKey || event.metaKey)) {
      onClick();
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <Input
        autoFocus
        label="Equation"
        type="text"
        value={equation}
        placeholder="e.g., x = \\frac{-b \\pm \\sqrt{b^2-4ac}}{2a}"
        onChange={(event) => setEquation(event.target.value)}
        onKeyDown={handleOnKeyDown}
      />

      <div className={clsx("border-default flex min-h-18 items-center justify-center rounded-lg border")}>
        {equation === "" ? (
          <span className="text-default-500 text-sm">Visualization</span>
        ) : (
          <KatexRenderer equation={equation} inline={false} onDoubleClick={() => null} />
        )}
      </div>
      <div className="flex justify-end gap-2 pb-2">
        <Button color="primary" onPress={onClick}>
          Confirm
        </Button>
      </div>
    </div>
  );
}
